import * as React from 'react';
import { SVGProps } from 'react';
const ForCorporates = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={48}
    height={60}
    viewBox='0 0 48 60'
    fill='none'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.36679 6.34676C6.29706 7.08915 4.96892 7.16033 4.38318 6.56158C3.78763 6.42469 3.39926 5.9018 3.2186 4.99413C2.60247 3.61104 3.12956 1.40161 3.99616 2.49571C4.71289 0.681232 7.58884 1.73383 9.21028 0.726562C10.1946 1.36348 9.82039 2.93684 9.1131 3.46864C9.14092 5.27889 9.04033 6.24546 8.36679 6.34676Z'
      fill='#282829'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.4527 22.5312C21.8738 22.9046 19.0916 23.419 19.0916 23.419C19.0916 23.419 17.6663 25.0619 17.7973 25.3496C17.9279 25.6373 18.0191 25.5361 18.2704 25.7551C18.5222 25.9738 19.0488 26.1297 19.0488 26.1297C19.0488 26.1297 19.4839 26.4174 19.9005 26.231C20.3175 26.0454 21.158 24.7538 21.6127 24.5504C21.706 24.5093 22.1115 24.3318 22.6994 24.0707L22.4527 22.5312Z'
      fill='#FFB27D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M27.7673 14.0481C27.8341 13.5408 28.0936 13.04 28.1963 12.5234C28.3376 13.8099 29.4414 15.4846 31.0158 17.4491C30.9032 18.3398 30.5255 20.0398 30.0464 21.2471C28.2811 22.4743 26.0564 23.2565 22.4658 24.2053C22.1486 23.9689 21.8257 23.2854 21.6776 22.779C24.7278 21.1416 25.8847 20.3869 27.254 19.9636C27.2471 17.3944 27.772 15.66 27.7673 14.0481Z'
      fill='#FF5612'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.6053 32.0135C12.4949 31.7308 12.3532 31.1533 12.205 30.4609C11.6809 30.4643 11.1132 30.4931 10.6658 30.752C10.7206 30.9164 11.1817 32.3 11.1817 32.4601C11.1817 35.8196 11.6202 34.8272 12.2179 35.0759C12.4225 35.1615 12.7513 35.0865 12.8537 34.9801C12.956 34.8737 13.582 34.9581 13.582 34.8945C13.582 34.8309 13.8384 34.3818 13.582 34.0085C13.3255 33.6343 14.2901 34.3932 14.2901 34.1043C14.2901 33.7873 12.8267 32.5805 12.6053 32.0135Z'
      fill='#FFB27D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.714 35.6973V34.5159C14.714 34.4918 14.6956 34.4735 14.6729 34.4735H11.3354C11.3127 34.4735 11.2943 34.4917 11.2943 34.5159V35.6973H10.6379V34.5159C10.6379 34.1154 10.9509 33.7892 11.3354 33.7892H14.6729C15.0574 33.7892 15.3708 34.1154 15.3708 34.5159V35.6973H14.714Z'
      fill='#F57A44'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.94312 43.5432H18.5782V36.6543C18.5782 35.978 18.0237 35.4297 17.3404 35.4297H9.37402C8.58366 35.4297 7.94312 36.0636 7.94312 36.8454V43.5432Z'
      fill='#FC9774'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.8364 35.5312C17.3115 35.741 16.9412 36.2499 16.9412 36.8453V43.543H18.578V36.6542C18.578 36.152 18.2727 35.7211 17.8364 35.5312Z'
      fill='#F57A44'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.2901 34.4755C14.2901 34.4755 14.0627 33.9717 13.8221 33.9928C13.5819 34.0124 13.7541 34.4755 13.7541 34.4755C13.7541 34.4755 14.0709 34.6921 14.2901 34.4755Z'
      fill='#FFB27D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.8114 33.9898C11.8114 33.9898 11.3567 34.8183 11.4912 34.9522C11.6261 35.0843 12.0551 35.0365 12.0551 35.0365C12.0551 35.0365 12.5907 35.2115 12.7589 35.0449C12.7589 35.0449 13.5819 35.0191 13.5819 34.8967C13.5819 34.7751 13.1871 33.7894 13.0039 33.7894C12.8215 33.7894 12.7444 34.4538 12.7444 34.4538C12.7444 34.4538 12.6643 33.9284 12.5243 33.7894C12.3839 33.6513 12.1055 34.4538 12.1055 34.4538C12.1055 34.4538 12.1694 33.8377 11.8114 33.9898Z'
      fill='#FFB27D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.3869 24.1641C16.0086 24.4624 18.834 24.6277 18.834 24.6277C18.834 24.6277 20.4563 26.0806 20.3626 26.3824C20.2693 26.6841 20.166 26.5951 19.9443 26.8434C19.7225 27.0917 19.2199 27.3121 19.2199 27.3121C19.2199 27.3121 18.8251 27.6511 18.3875 27.5181C17.9508 27.3854 16.9531 26.2082 16.4762 26.0633C16.3781 26.0336 15.9534 25.9082 15.3373 25.7222L15.3869 24.1641Z'
      fill='#FFB27D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.24921 56.1005L3.04541 57.2087C3.04541 57.2087 3.81909 58.66 4.61678 59.449C5.41442 60.238 6.47286 60.1308 6.47286 59.4592C6.47286 58.7871 5.09249 57.1074 5.09249 56.3018C5.09244 55.4959 3.24921 56.1005 3.24921 56.1005Z'
      fill='#686868'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.67863 56.2968L8.37292 58.3452C8.37292 58.3452 9.59444 58.3452 10.4427 58.3452C11.2913 58.3452 13.6325 58.3452 13.6325 58.3452C13.6325 58.3452 13.4629 57.8406 11.9357 57.5385C10.4089 57.2371 10.3241 56.7117 10.3241 56.7117L10.4427 55.39L9.05153 55.1875L8.67863 56.2968Z'
      fill='#686868'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.47266 32.8474L9.57768 43.6487L8.44048 56.6688H10.4426L13.1914 42.8995L10.4426 27.1328L6.47266 32.8474Z'
      fill='#252525'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.4428 26.7109L8.5931 32.8535C8.5931 32.8535 5.76038 42.0251 5.30225 47.3305C4.84412 52.6366 5.30225 56.2639 5.30225 56.2639L2.77439 56.6673C2.77439 56.6673 1.31522 45.6524 1.85813 41.9577C2.40104 38.264 1.73694 29.264 1.73694 29.264L2.77439 26.7109H10.4428Z'
      fill='#252525'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M36.8807 15.6451C35.7384 17.0023 34.7797 17.9833 34.0048 18.588C34.7112 16.1062 35.4678 13.4336 36.274 10.5703C36.5579 10.8076 36.7861 11.0428 36.9582 11.2758C37.0216 12.4369 37.0374 13.3225 37.0049 13.9336C36.5862 14.2611 36.2496 14.4662 35.9949 14.5492C36.3802 14.8946 36.6756 15.2599 36.8807 15.6451Z'
      fill='#FFAF8E'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M29.7249 14.9805C30.2802 16.1987 30.9044 17.3047 31.5972 18.2988C31.393 15.2661 31.2893 12.7109 31.2864 10.6328C30.9755 10.8048 30.7439 10.9701 30.5731 11.1498C30.5401 11.1879 30.5084 11.226 30.478 11.2642C30.15 12.4249 29.9376 13.3329 29.8409 13.9897C30.1474 14.1283 30.4065 14.2483 30.6184 14.3499C30.3307 14.5415 30.0327 14.7516 29.7249 14.9805Z'
      fill='#FFAF8E'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M36.9582 11.2812C38.7201 12.2923 40.1605 13.1881 41.2801 13.9691C42.0354 16.8184 42.4447 19.896 42.5081 23.2029C42.4048 27.0031 42.023 29.7532 41.5691 31.2351C40.9081 31.2638 40.205 31.1994 39.9438 30.9507C39.8008 27.6077 39.7645 24.8953 39.8351 22.8131C39.3517 21.7147 38.927 20.8939 38.5609 20.3507C38.4012 21.4817 38.1807 22.4626 38.128 23.4732C38.3147 25.5436 38.4059 28.0162 38.9651 30.8905C38.2685 31.5516 36.7275 31.9457 34.3427 32.0732C33.8957 26.6306 33.7831 22.1376 34.0048 18.5934C34.7798 17.9887 35.7385 17.0078 36.8808 15.6505C36.6757 15.2653 36.3803 14.9 35.9949 14.5547C36.2497 14.4716 36.5862 14.2665 37.0049 13.939C37.0374 13.328 37.0216 12.4423 36.9582 11.2812Z'
      fill='#FF5612'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M31.5972 18.3077C30.9139 25.525 30.6278 30.2171 30.2258 31.8438C29.0826 31.7197 28.2019 31.1891 27.6697 30.6654C27.8127 26.5593 28.2969 23.9372 28.5016 21.5366C28.1325 17.5954 27.3764 13.9719 28.1911 12.2879C29.0667 11.7044 29.8289 11.3663 30.4779 11.2734C30.15 12.4337 29.9376 13.3418 29.8408 13.9986C30.1474 14.1371 30.4064 14.2571 30.6183 14.3588C30.3306 14.5503 30.0326 14.7605 29.7247 14.9893C30.2802 16.2076 30.9045 17.3136 31.5972 18.3077Z'
      fill='#FF5612'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M30.8063 27.1653C31.0135 24.8877 31.2558 21.9117 31.5971 18.3052C31.3967 15.3255 31.2931 12.8063 31.2867 10.7477C31.3693 10.7172 31.875 10.4308 31.9713 10.4058C31.9576 10.9122 31.5551 11.5876 31.5958 11.9164C31.7251 11.5266 31.9627 11.2087 32.3095 10.9626C32.4174 11.1681 32.45 11.3918 32.6229 11.6427C32.8092 11.4511 32.9851 11.268 33.1008 11.1282C33.4501 11.5435 33.7023 11.9787 34.0196 12.4168C34.6404 11.6113 34.9589 10.832 35.5232 10.3672C35.716 10.4651 36.0867 10.6023 36.24 10.6922C35.4462 13.5106 34.7012 16.1433 34.005 18.5904C33.8517 21.0303 33.8577 23.9207 34.0221 27.2611C33.7426 27.3035 33.4565 27.3311 33.1632 27.3442V27.3154C33.1632 27.2497 33.1076 27.1938 33.0395 27.1921L31.8346 27.1586C31.7666 27.1569 31.7104 27.209 31.7104 27.2751V27.2972C31.4151 27.2662 31.1137 27.2221 30.8063 27.1653Z'
      fill='#DEDEDE'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M32.0998 12.6277C32.313 12.287 32.5605 12.0857 32.8418 12.0234C33.0516 12.1141 33.2763 12.3247 33.5166 12.6561C33.3295 12.976 33.1304 13.1998 32.9206 13.3265C33.315 15.7863 33.4973 19.211 33.4678 23.6002C33.1685 24.254 32.8757 24.7261 32.5883 25.0168C32.2415 24.5104 32.0266 23.9879 31.9431 23.4494C32.2171 18.8424 32.3798 15.4804 32.432 13.3642C32.2342 13.1074 32.1233 12.8616 32.0998 12.6277Z'
      fill='#747474'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M33.5162 11.7571C33.654 11.941 33.7799 12.1279 33.9066 12.3165C33.7911 12.3928 33.6429 12.4813 33.4622 12.583C33.3016 12.372 33.1479 12.2152 33.0015 12.1139C33.1771 11.9851 33.3488 11.866 33.5162 11.7571ZM32.3773 11.4609C32.4423 11.6881 32.5327 11.8982 32.6479 12.0914C32.4886 12.1686 32.3413 12.2957 32.2069 12.4728C32.1306 12.3546 32.0673 12.1542 32.0168 11.8715C32.1144 11.7199 32.2342 11.583 32.3773 11.4609Z'
      fill='#FFAF8E'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M28.0264 44.6129C28.0105 40.9199 28.136 36.5722 28.4036 31.5704C28.9045 31.867 29.5472 32.0946 30.371 32.2695C30.5696 31.7526 30.7499 30.5254 31.0162 28.2812C31.2444 28.3418 31.4756 28.3906 31.7107 28.4274V28.5546C31.7107 28.6207 31.7668 28.6766 31.8349 28.6783L33.0393 28.7122C33.1078 28.7139 33.1638 28.6614 33.1638 28.5952V28.5046C33.3818 28.4948 33.6027 28.4762 33.8258 28.4478C33.9508 30.3352 33.9996 31.5979 34.0972 32.5208C36.0758 32.2767 37.2652 32.064 38.2208 31.6686C38.7098 35.3887 38.9804 39.4015 39.0331 43.706C39.8427 45.4251 40.0645 49.624 39.6976 56.3031C39.0078 56.4544 38.2259 56.4544 37.3517 56.3031C36.6623 53.2983 36.0629 49.3448 35.553 44.4425C34.8358 42.0958 34.093 38.7969 33.3244 34.5463C33.1698 37.4295 32.7524 40.6906 32.0733 44.3293C32.3024 47.0171 31.905 50.9643 30.8809 56.1709C30.3431 56.2217 29.4958 56.1463 28.3397 55.9442C28.4571 51.7106 28.3531 47.9334 28.0264 44.6129Z'
      fill='#252525'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M34.0972 32.5165C33.9996 31.5936 33.9508 30.3308 33.8258 28.4435C33.9118 28.4329 33.9979 28.4206 34.0844 28.4071C34.1525 29.5741 34.2385 30.7919 34.3426 32.0619C36.0604 31.9699 37.3397 31.7398 38.1819 31.3716C38.1952 31.469 38.208 31.5665 38.2208 31.6644C37.2652 32.0598 36.0758 32.2725 34.0972 32.5165ZM30.371 32.2652C29.5472 32.0902 28.9045 31.8626 28.4036 31.566C28.4095 31.4546 28.4155 31.3432 28.4215 31.2313C28.9083 31.5224 29.5164 31.7559 30.2258 31.833C30.3949 31.1483 30.5439 29.9198 30.7105 28.1875C30.8115 28.2197 30.9134 28.2494 31.0162 28.2769C30.7499 30.5211 30.5696 31.7483 30.371 32.2652Z'
      fill='#252525'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M39.7729 57.4152C39.662 57.5203 39.6261 57.4907 39.5477 57.439C39.4201 56.7487 38.1052 56.6682 37.7785 57.3724C37.6818 57.3352 37.6133 57.2754 37.5735 57.1932C37.344 57.6395 36.8246 58.0772 36.9629 58.8552C37.3123 59.3527 39.1114 59.5997 39.9635 58.5814C40.2049 58.1941 39.9069 57.7034 39.7729 57.4152ZM30.7006 56.6571C30.9207 57.247 30.9699 57.7318 30.7104 57.9224C30.0489 58.0538 28.6934 58.0377 26.6053 58.3093C25.1311 58.2047 24.4927 57.7894 24.8656 57.3275C26.1467 57.4059 27.3031 57.0753 28.3354 56.3359C28.5277 57.1084 29.3164 57.2152 30.7006 56.6571Z'
      fill='#686868'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M39.6381 56.3153C39.6732 56.7285 39.7083 57.1056 39.743 57.448C39.6548 57.5204 39.6185 57.4916 39.5478 57.445C39.4202 56.7547 38.1053 56.6742 37.7786 57.3785L37.7765 57.3776L37.7743 57.3772L37.7722 57.3759L37.77 57.375H37.7696L37.7679 57.3742L37.7658 57.3733H37.7653L37.7636 57.3724L37.7614 57.3715L37.761 57.3711L37.7593 57.3707L37.7572 57.3699L37.7567 57.3694L37.755 57.369L37.7529 57.3677L37.752 57.3673L37.7507 57.3668L37.7486 57.366L37.7477 57.3655L37.7468 57.3647L37.7447 57.3638L37.7438 57.3633L37.7426 57.3629L37.7405 57.3621L37.7395 57.3612L37.7387 57.3608L37.7365 57.3599L37.7353 57.359L37.7344 57.3586L37.7327 57.3577L37.731 57.3569H37.7306L37.7284 57.3556L37.7271 57.3547L37.7267 57.3543L37.7245 57.3534L37.7233 57.3526H37.7229L37.7207 57.3513L37.719 57.3505L37.7168 57.3492L37.7151 57.3483L37.713 57.3471L37.7113 57.3458L37.7058 57.3425L37.7036 57.3416V57.3411L37.7019 57.3403L37.7002 57.339H37.6998L37.6985 57.3382L37.6968 57.3369L37.696 57.3365L37.6951 57.3356L37.6929 57.3344L37.6925 57.3339L37.6912 57.3331L37.6895 57.3322L37.6891 57.3317L37.6874 57.3309L37.6861 57.3296L37.6852 57.3292L37.6822 57.3271L37.6818 57.3267L37.6809 57.3258L37.6787 57.3245L37.6779 57.3237H37.677L37.6757 57.3224L37.6745 57.3211L37.674 57.3207L37.6723 57.3195L37.671 57.3186L37.6689 57.3169L37.6677 57.3161L37.6672 57.3156L37.6659 57.3144L37.6643 57.3135V57.313L37.6626 57.3118L37.6613 57.3106H37.6608L37.6596 57.3093L37.6579 57.3081C37.7152 57.0309 37.7645 56.7178 37.8043 56.3682C38.4736 56.4466 39.085 56.4293 39.6381 56.3153ZM28.5749 55.9844C28.5244 56.1666 28.4571 56.3263 28.3728 56.4632C28.3801 56.4836 28.3883 56.503 28.3968 56.5225C28.4345 56.6081 28.4824 56.6827 28.5407 56.7458L28.5416 56.7467C28.5608 56.7675 28.5809 56.7874 28.6023 56.8056L28.6036 56.8065C28.6101 56.8124 28.6169 56.8179 28.6237 56.8234L28.6267 56.826C28.7004 56.8845 28.7868 56.9294 28.8849 56.9603L28.8871 56.9612C28.8961 56.9638 28.9047 56.9667 28.9136 56.9692L28.9188 56.9705C28.9278 56.9731 28.9367 56.9751 28.9462 56.9777L28.9492 56.9786C28.959 56.9807 28.9689 56.9832 28.9787 56.9854L28.9805 56.9858C28.9903 56.9879 29.0002 56.9896 29.0104 56.9917L29.0156 56.9926L29.0443 56.9977L29.0473 56.9982C29.1466 57.0134 29.2562 57.018 29.3753 57.0117L29.3804 57.0112L29.4159 57.0091L29.4215 57.0087L29.457 57.0057L29.4647 57.0048L29.5003 57.0014L29.5062 57.0006L29.5456 56.9959L29.5465 56.9955L29.5872 56.9904L29.5966 56.9887C29.6947 56.9743 29.7987 56.9535 29.9079 56.9264L29.9199 56.9234L29.9623 56.9128L29.9678 56.9111L30.0098 56.9001L30.0226 56.8967L30.0612 56.8857L30.0749 56.8819L30.1134 56.8709L30.1297 56.8657L30.1686 56.8539L30.1798 56.8505L30.2235 56.837L30.235 56.8332L30.2787 56.8188L30.2885 56.8154L30.3343 56.8001L30.3455 56.7963L30.3908 56.7802L30.4473 56.7603C30.4833 56.7472 30.5193 56.7336 30.5561 56.7197L30.5646 56.7167L30.6212 56.6947C30.619 56.5294 30.6276 56.3591 30.6469 56.1844C30.1522 56.198 29.4616 56.1314 28.5749 55.9844Z'
      fill='#FFB27D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M37.8486 23.3799C37.9728 21.8434 38.0902 20.5213 38.2001 19.4141C38.2789 19.7293 38.3988 20.0391 38.5607 20.3438C38.401 21.4748 38.1805 22.4558 38.1278 23.4664C38.3145 25.5368 38.4057 28.0093 38.9649 30.8836C38.9015 30.9438 38.8308 31.0023 38.7529 31.0583C38.2978 29.287 37.9964 26.7275 37.8486 23.3799Z'
      fill='#FFAF8E'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M34.0845 28.4141C32.8848 28.601 31.76 28.5277 30.7106 28.1942C30.7419 27.8688 30.7735 27.5251 30.8065 27.1641C31.9629 27.3772 33.0351 27.4086 34.0224 27.259C34.0408 27.6383 34.0618 28.0235 34.0845 28.4141Z'
      fill='#A0795F'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M33.0397 27.1898L31.8349 27.1563C31.7664 27.1542 31.7107 27.2076 31.7107 27.2758V28.5538C31.7107 28.6216 31.7663 28.6784 31.8349 28.6801L33.0397 28.714C33.1082 28.7157 33.1639 28.6623 33.1639 28.5945V27.3161C33.1639 27.2483 33.1082 27.1915 33.0397 27.1898Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M32.9246 27.4182V28.4792L31.9501 28.4521V27.3906L32.9246 27.4182Z'
      fill='#A0795F'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M35.0092 34.1953L35.5028 45.533L48 44.2313L46.5203 34.1953H35.0092Z'
      fill='#FF5612'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M33.4194 44.1347C34.426 44.5008 35.0088 45.0022 35.5028 45.5314L35.0092 34.1937L34.4474 34.1797L33.4194 44.1347Z'
      fill='#FF5612'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M35.0092 34.1953L36.4628 38.7434C36.6717 39.2477 36.8862 39.6892 37.7326 39.6197L45.7534 39.1163C46.468 39.0718 46.4851 38.7137 46.4915 38.2289V34.1953H35.0092Z'
      fill='#747474'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M40.7988 38.8102L42.8389 38.6802C42.9511 38.6729 43.0633 38.7505 43.0804 38.8611L43.3579 40.6544C43.375 40.7646 43.3044 40.8667 43.1943 40.8777L41.0715 41.09C40.961 41.1014 40.842 41.0209 40.83 40.909L40.6351 39.0339C40.6236 38.9221 40.6866 38.8175 40.7988 38.8102Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M41.1761 39.2956L41.3076 40.5605L42.8031 40.4109L42.616 39.2032L41.1761 39.2956Z'
      fill='#FF5612'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M37.4065 34.189C37.532 33.7491 37.8244 33.3826 38.2192 33.0957C38.3896 32.972 38.5788 32.8639 38.7826 32.7719C38.9034 32.4622 39.6278 32.2012 40.5133 32.1677C41.4509 32.1321 42.2289 32.3643 42.3056 32.6931C42.3647 32.7181 42.422 32.7452 42.479 32.7741C43.0677 33.0724 43.5075 33.5393 43.6504 34.189H43.2184C43.0805 33.7127 42.738 33.3657 42.2906 33.1384C42.2302 33.108 42.1677 33.0795 42.1038 33.0529C41.8093 33.261 41.2321 33.4161 40.5629 33.4414C39.8615 33.4681 39.2501 33.3452 38.9539 33.1435C38.7762 33.2245 38.6113 33.319 38.4636 33.4262C38.1814 33.6309 37.9644 33.8864 37.8492 34.189H37.4065Z'
      fill='#FFAF8E'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M39.4546 32.6835C39.4477 32.9559 39.3488 33.3679 39.5244 33.5641C39.9851 34.0785 41.1124 34.1141 41.5971 33.7836C41.8056 33.6416 41.8296 33.1776 41.8352 32.8801C41.586 32.2496 41.4511 31.6669 41.431 31.1309C40.9373 30.8067 40.1919 30.7758 39.944 30.9445L39.4546 32.6835Z'
      fill='#FFB27D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M34.9146 9.72871C34.7459 9.52188 34.9069 8.54603 34.7917 8.20068C34.853 8.01677 34.9159 7.7837 34.9806 7.50237C36.1687 6.66633 36.3207 6.06331 35.4361 5.69296C35.2614 5.79466 35.0491 6.10143 34.7982 6.6125C34.5888 6.60867 34.7857 6.06883 34.6736 5.86797C34.9044 5.00902 34.6933 4.74971 34.7571 4.21578C34.1435 3.35474 32.6565 3.12381 30.8214 3.39878C30.6656 5.07214 30.1437 9.02106 32.1886 8.89307L32.4339 8.84182C32.544 9.52531 32.5667 10.4834 32.7413 11.0754L32.779 11.1585C33.4413 10.7774 33.8288 10.8503 34.9146 9.72871Z'
      fill='#FFB27D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M30.9165 3.5283C32.7515 3.25328 34.1435 3.34862 34.7571 4.20966C34.6933 4.74359 34.8427 5.06985 34.6128 5.9288C34.7245 6.12966 34.5888 6.60256 34.7982 6.60638C35.0491 6.09537 35.2615 5.78854 35.4361 5.68684C36.3207 6.05719 36.1687 6.66021 34.9806 7.49625C34.9159 7.77763 34.853 8.0107 34.7917 8.19456C36.879 6.98096 37.7931 4.04056 35.8909 2.6613C35.5055 0.224313 31.9655 2.46129 30.1428 1.32056C29.4496 2.31257 30.3594 3.51811 30.9165 3.5283Z'
      fill='#282829'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M36.0887 3.5017C35.9149 3.25506 35.9016 3.04068 36.0493 2.85847C36.4642 2.77203 36.8016 2.87034 37.0611 3.15257C36.8646 3.10341 36.5405 3.21992 36.0887 3.5017Z'
      fill='#282829'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M35.6595 2.74669C35.8304 2.93651 35.9875 2.97807 36.131 2.8721C36.2192 2.51487 36.1674 2.20048 35.9747 1.92969C35.9991 2.11191 35.8941 2.38394 35.6595 2.74669Z'
      fill='#282829'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M32.2087 3.39324C32.1937 2.86567 31.986 2.54999 31.5857 2.44531C30.9097 2.75254 30.538 3.239 30.4695 3.9047C30.6951 3.63261 31.2749 3.46228 32.2087 3.39324Z'
      fill='#282829'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M33.4348 1.54242C33.3535 1.76659 33.4597 2.0598 33.139 2.12844C32.9266 3.09545 32.1555 1.79074 32.1709 1.42969C32.3079 1.53138 32.7288 1.56911 33.4348 1.54242Z'
      fill='#282829'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M34.7597 7.60659L35.2221 10.6097C35.2221 10.6097 34.7682 11.5695 34.1898 12.4521L32.8269 11.7368L31.9064 12.308C31.8901 11.3656 32.192 10.4554 32.192 10.4554C32.192 10.4554 32.6544 8.75279 32.5166 7.90104C32.3765 7.05447 34.7597 7.60659 34.7597 7.60659Z'
      fill='#FFB27D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M33.6536 8.58594C33.3569 8.73088 32.9501 8.81518 32.4338 8.83894C32.444 9.01226 32.4363 9.21143 32.4252 9.33469C32.9446 9.23593 33.3543 8.98596 33.6536 8.58594Z'
      fill='#F08261'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M34.9214 3.53906C35.184 3.78694 35.2365 4.00857 35.079 4.20352C34.5648 4.31073 34.1187 4.22345 33.7415 3.94207C34.0001 3.98442 34.3931 3.85012 34.9214 3.53906Z'
      fill='#282829'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M34.0282 13.325C34.9218 12.3698 35.5418 11.4359 35.889 10.5218C35.6942 10.157 35.3872 9.79089 35.1719 9.6875C34.1327 10.7613 33.4712 11.3613 32.8376 11.7262C32.8337 11.7283 32.8303 11.7308 32.8264 11.7325C32.8183 11.7041 32.8101 11.6753 32.8016 11.6465C32.6342 11.0795 32.3914 10.4227 32.2861 9.76892C31.9876 9.97822 31.8802 10.2969 31.717 10.6168C31.4516 11.3253 31.3591 12.1669 31.4396 13.1419C31.6361 12.8704 31.8326 12.6292 32.0288 12.419C32.295 12.1334 32.561 11.905 32.8264 11.7326C33.061 11.93 33.2862 12.1767 33.5025 12.4724C33.684 12.7215 33.8595 13.0059 34.0282 13.325Z'
      fill='#FF5612'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.56213 9.63281L9.83207 10.8719L11.3456 25.8251C11.3456 25.8251 12.4631 29.1192 12.8682 31.0078C12.3446 31.0112 10.9555 31.3905 10.5077 31.6489C9.88942 29.7832 9.09219 26.1767 9.09219 26.1767L8.56213 9.63281Z'
      fill='#F57A44'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.56118 29.5457C5.72004 29.388 12.5295 30.8093 12.5295 30.8093L11.0027 20.0923L9.63209 13.6484L7.69595 9.00835C7.69595 9.00835 4.79302 8.30791 4.58621 8.43798L4.0647 16.7532L5.56118 29.5457Z'
      fill='#F57A44'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.84973 9.76179C2.84973 9.76179 6.10849 8.03504 8.22784 10.1338C10.3476 12.2314 10.5185 18.1571 10.5185 18.1571V25.0078L10.8229 28.0579L2.88359 27.124L3.95273 16.6663L2.84973 9.76179Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.5777 19.9276L4.37512 9L1.02647 10.1416L2.19706 19.9275L0.00830078 30.9094C0.00830078 30.9094 8.53382 30.1788 9.5777 31.2115V19.9276Z'
      fill='#FC9774'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.57781 26.403C7.26661 25.6869 4.98921 24.9551 4.4797 24.7047C4.00956 24.4733 2.9246 23.2232 1.87691 21.5325L2.19713 19.9269L1.80493 16.6484C3.23111 18.5896 6.17989 20.7791 7.085 21.7148C7.43264 22.0737 8.40461 22.519 9.57776 22.9631L9.57781 26.403Z'
      fill='#F57A44'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.15198 10.1406C8.15198 10.1406 10.0864 16.2099 10.0864 18.0689C10.0864 19.9266 11.6137 30.8076 11.6137 30.8076H12.5295L11.257 18.0689L9.68523 12.2403L8.15198 10.1406Z'
      fill='#F57A44'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.69592 9L10.2435 20.084L9.68515 12.2336L9.17262 11.7031L9.57767 11.7929L8.56206 9.6225L7.69592 9Z'
      fill='#FC9774'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.0577 23.8516L16.5648 24.1351L16.0622 26.5093L14.3165 26.0932L15.0577 23.8516Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.02648 10.1406C1.02648 10.1406 0.181286 10.1406 0.00836932 13.3797C-0.207036 17.4206 3.79757 23.1001 4.86626 23.6048C5.93495 24.1082 15.0681 26.7104 15.0681 26.7104L15.7467 23.7954C15.7467 23.7954 8.45854 21.905 7.38212 20.8398C6.30655 19.7753 3.40664 15.5489 2.77423 13.5623C2.24202 11.892 1.02648 10.1406 1.02648 10.1406Z'
      fill='#FC9774'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.57778 19.9284L4.06478 12.9518L4.46596 12.2606H3.79804L2.80383 9.53685L3.06328 9.51562L5.5021 11.4674L9.57778 19.9284Z'
      fill='#F57A44'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.8026 25.8423C14.8026 25.9452 14.7186 26.0278 14.615 26.0278C14.5114 26.0278 14.4275 25.9452 14.4275 25.8423C14.4275 25.7401 14.5114 25.6562 14.615 25.6562C14.7187 25.6562 14.8026 25.7402 14.8026 25.8423Z'
      fill='#FFAF8E'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.0037 25.6309C14.0037 25.733 13.9197 25.8165 13.8165 25.8165C13.7129 25.8165 13.6285 25.733 13.6285 25.6309C13.6285 25.5288 13.7129 25.4453 13.8165 25.4453C13.9197 25.4453 14.0037 25.5288 14.0037 25.6309Z'
      fill='#FFAF8E'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.1915 25.4118C13.1915 25.5143 13.1075 25.5973 13.0039 25.5973C12.9003 25.5973 12.8164 25.5143 12.8164 25.4118C12.8164 25.3088 12.9003 25.2266 13.0039 25.2266C13.1075 25.2266 13.1915 25.3088 13.1915 25.4118Z'
      fill='#FFAF8E'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.77675 9.24605C4.84526 9.81557 5.24086 10.327 5.83816 10.5131C6.43933 10.6999 7.01006 10.8436 7.3243 10.9178C7.43263 10.9445 7.88519 10.6817 7.88092 10.5716C7.8651 10.1707 7.60007 9.50292 7.68269 8.77107C7.73105 8.33968 7.77902 7.94731 7.80428 7.71041C7.67712 7.39429 6.71078 4.98996 6.77246 5.14335V5.14081L6.57338 4.64844C6.57327 4.64844 4.74592 8.99056 4.77675 9.24605Z'
      fill='#FFB27D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.43474 7.60428C5.60429 7.77254 7.26681 9.08699 7.62395 9.31284C7.68858 8.72553 7.8042 7.71195 7.8042 7.71195C7.8042 7.71195 7.5002 7.97086 6.77619 5.125C6.77619 5.125 6.77448 5.13136 6.77237 5.1424V5.14493C6.73119 5.38854 5.19668 7.37127 5.43474 7.60428Z'
      fill='#F08261'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.53221 8.10288C8.53221 8.10288 5.33723 8.58 4.86117 6.42693C4.38506 4.27475 3.6152 2.92978 5.81681 2.32129C8.01838 1.7136 8.63365 2.44118 8.96894 3.12135C9.30463 3.80141 9.42537 7.83716 8.53221 8.10288Z'
      fill='#FFB27D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.57765 19.9278L4.79293 12.7419L5.30203 11.6673L4.23289 11.7338L2.77417 9.4905L4.58616 8.4375L9.57765 19.9278Z'
      fill='#FC9774'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.91531 2.31408C3.75645 2.49033 3.61 2.52935 3.47731 2.43059C3.3951 2.09836 3.44346 1.80639 3.622 1.55469C3.5993 1.72383 3.69734 1.97678 3.91531 2.31408Z'
      fill='#282829'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.05034 2.97629C4.65986 2.82375 4.3649 2.87504 4.16492 3.12928C4.18034 3.7077 4.48393 4.87174 4.9493 5.12643C5.03021 5.07046 5.01137 3.84583 5.05034 2.97629Z'
      fill='#282829'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.39914 4.03156C4.91382 3.92266 4.86541 4.96935 4.82644 5.48797C4.7498 6.50837 3.58819 4.2019 4.39914 4.03156Z'
      fill='#FFB27D'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.52886 2.7C3.75235 2.52921 3.82472 2.34238 3.74506 2.14023C3.40124 1.94911 3.07499 1.94319 2.76501 2.12159C2.9534 2.13262 3.20773 2.32542 3.52886 2.7Z'
      fill='#282829'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.19625 2.41406C4.53687 2.73103 4.31941 3.01663 4.5433 3.27088C5.53837 3.41621 6.49099 3.30984 7.40128 2.95182C6.8528 3.00307 6.11809 2.82383 5.19625 2.41406Z'
      fill='#282829'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.06577 3.39594C8.31992 2.65017 6.91127 2.5603 4.97081 3.26204C3.74287 2.96033 3.46715 2.39886 3.98559 1.48523C4.71819 0.194047 6.30408 1.21489 8.2475 0C8.17347 0.944146 11.0652 1.75265 9.06577 3.39594Z'
      fill='#282829'
    />
  </svg>
);
export default ForCorporates;
